export class IngInputBase<T>{
  value: T;
  key: string;
  label: string;
  description: string;
  required: boolean;
  order: number;
  controlType: string;
  placeHolder: string;
  readonly: boolean;
  groupId: string;
  classContainer: string;
  constructor(
    options: {
      value?: T,
      key?: string,
      label?: string,
      description?: string,
      required?: boolean,
      order?: number,
      groupId?: string,
      readonly?: boolean,
      controlType?: string,
      placeHolder?: string,
      classContainer?: string
    } = {}
  ) {
    this.key            = options.key || '';
    this.value          = options.value;
    this.label          = options.label || '';
    this.description    = options.description || '';
    this.order          = options.order === undefined ? 1 : options.order;
    this.required       = options.required;
    this.readonly       = options.readonly;
    this.groupId        = options.groupId || null;
    this.controlType    = options.controlType || 'text';
    this.placeHolder    = options.placeHolder || '';
    this.classContainer = options.classContainer || 'col-md-12';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/inputs/ing-input-base.ts